import Model from './Model';
import PostTypes from './PostTypes';
import Routes from './Routes';
import Store from './Store';
import Search from './Search';
import Notification from './Notification';
import ThemeMode from './ThemeMode';
import Admin from './Admin';
const extenders = {
  Model,
  PostTypes,
  Routes,
  Store,
  Search,
  Notification,
  ThemeMode,
  Admin
};
export default extenders;
flarum.reg.add('core', 'common/extenders', extenders);